import {I18n} from 'vue-i18n';

export function formatDate(timestamp: number, i18n: I18n): string {
    const date = new Date(timestamp * 1000); // Convert seconds to milliseconds

    // Use the date formatting option directly
    return i18n.global.d(date, {key: 'long'});
}